import type { BaseTaskTodo, TableCells } from 'models';

import AttachIcon from 'shared/icons/Attach';

export const tasksTableCells: TableCells<BaseTaskTodo>[] = [
  {
    id: 'Space.Name',
    logicalName: 'Space',
    label: '##attribute#incident#uds_spaceid',
    type: 'string',
    canSort: false,
    style: { width: '20%' },
  },

  {
    id: 'RequestType.Label',
    label: '##attribute#incident#uds_requesttype',
    type: 'string',
    canSort: false,
    style: { width: '20%' },
  },
  {
    id: 'Priority.Label ',
    label: '##attribute#incident#prioritycode',
    type: 'string',
    canSort: false,
    style: { width: '20%' },
  },
  {
    id: 'Title',
    logicalName: 'Title',
    label: '##attribute#task#subject',
    type: 'string',
    canSort: true,
    style: { width: '30%' },
  },
  {
    id: 'HasTasks',
    type: 'string',
    label: '#portal.task.todo.grid.header.label.attachments',
    canSort: false,
    style: { width: '10%' },
    render: (task) =>
      task.HasFiles && <AttachIcon sx={{ fontSize: '1.3rem' }} />,
  },
];
